import {playFade} from '../common/help_functions';

export function initInfo(element) {
    playFade('.number')
    playFade('.title')
    playFade('.content-text')
}
